import React from "react";
import PropTypes from "prop-types";
import { FilterSelect } from "@td/ui";
import { loadProviders } from "../apis";
import { debounce } from "lodash";
import { map } from "lodash";

const LOAD_OPTIONS_LIMIT = 8;
const LOAD_OPTIONS_DEBOUNCE_DELAY = 500;

const ProviderFilter = React.memo(({ value, label, placeholder, onChange }) => {
  const loadOptions = async (inputValue, callback) => {
    const providers = await loadProviders({
      id: inputValue,
      nameSearchString: inputValue,
      except: map(value, ({ value }) => value.toString()),
    }, LOAD_OPTIONS_LIMIT);

    callback(providers.map(({ id, nameWithCredentials }) => ({ value: parseInt(id), label: nameWithCredentials })));
  };

  const debouncedLoadOptions = debounce((inputValue, callback) => {
    loadOptions(inputValue, callback);
  }, LOAD_OPTIONS_DEBOUNCE_DELAY);

  return (
    <FilterSelect
      async
      isMulti
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      defaultOptions={value}
      loadOptions={debouncedLoadOptions}
    />
  );
});

ProviderFilter.propTypes = {
  value:       PropTypes.array.isRequired,
  onChange:    PropTypes.func.isRequired,
  label:       PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
};

ProviderFilter.displayName = "ProviderFilter";

export default ProviderFilter;
